<template>
	<v-app>
		<navbar @drawer="drawer = true" :loading="navbarLoading" v-if="authenticated && !loading"></navbar>
		<navigation-drawer v-model="drawer" v-if="authenticated"></navigation-drawer>
		<v-main>
			<router-view
				v-if="(authenticated || $route.name === 'login') && !loading"
				@loading:active="navbarLoading = true"
				@loading:disable="navbarLoading = false"
			/>
			<loader height="100%" v-if="(!authenticated && $route.name !== 'login') || loading"></loader>
		</v-main>
		<balance-banner v-if="authenticated && !loading"></balance-banner>
		<footer-navigation v-if="authenticated && !loading"></footer-navigation>

		<v-snackbar
			v-model="snackbar"
			app
			transition="slide-y-reverse-transition"
			:color="stateColor"
			content-class="text-body-1"
		>
            {{ message }}

            <template v-slot:action="{ attrs }">
                <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                >
                {{$T('close')}}
                </v-btn>
            </template>
        </v-snackbar>
	</v-app>
</template>

<script>
import Navbar from './components/Navbar'
import NavigationDrawer from './components/NavigationDrawer'
import BalanceBanner from './components/BalanceBanner'
import FooterNavigation from './components/FooterNavigation'
import Loader from './components/Loader'
import { mapState } from 'vuex'
import { useNotifications, usePrices } from './configs/general.configs'
export default {
	name: 'App',

	data() {
		return {
			loading: false,
			drawer: false,
			navbarLoading: false,

			snackbar: false,
			messageState: false,
			message: null,
		}
	},

	watch: {
		'$route.name' () {
			this.navbarLoading = false;
			this.$store.dispatch('configurations/fetchAll');
			this.$store.dispatch('configurations/fetchSystemConfigValue');
			this.fetchNotifications();
		},
		'$i18n.locale'(val) {
			this.loading = true;
			setTimeout(() => {
				this.loading = false;
			}, 500);
			this.$vuetify.lang.current = val;
			this.$vuetify.rtl = val === 'ar';
		},
		authenticated (val) {
			console.log('authenticated', val)
			// if (val) {
			this.fetchData()
			// }
			this.fetchNotifications()
		}
	},

	computed: {
		...mapState({
			authenticated: state => state.auth.authenticated
		}),

		stateColor() {
			switch (this.messageState) {
			case 'info': return 'primary';
			case 'success': return 'success';
			case 'error': return 'red lighten-1';
			default: return '';
			}
		}
	},

	methods: {
		fetchNotifications() {
			if (useNotifications && this.authenticated) {
				this.$store.dispatch('notifications/fetchUnreadCount');
			}
		},

		fetchData () {
			this.$store.dispatch('vacations/fetchAll')
			this.$store.dispatch('entities/fetchEntityType').then(() => {
				this.$store.dispatch('configurations/fetchEnum').then(() => {
					this.$store.dispatch('configurations/fetchAll')
				})
			})
			this.$store.dispatch('configurations/fetchSystemConfigValue')
			if (usePrices) {
				this.$store.dispatch('profile/fetchBalance')
			}
		}
	},

	components: {
		Navbar,
		NavigationDrawer,
		BalanceBanner,
		FooterNavigation,
		Loader
	},

	created() {
		this.fetchData()
		this.fetchNotifications()
		this.$eventBus.$on('show-snackbar', (message, messageState) => {
			this.message = message;
			this.messageState = messageState || 'success';
			this.snackbar = true;
		})
		// تحديث الجرس/العدّاد عند وصول إشعار foreground
		this.$eventBus.$on('FCM-message', () => this.fetchNotifications())
	}
}
</script>

<style lang="scss">
@import './scss/vuetify-overrides.scss';
@media screen and (min-width: 600px) {
	*::-webkit-scrollbar{
		height: 4px;
		width: 4px;
		background-color: #f8f8f8;
	}
	*::-webkit-scrollbar-thumb{
		background-color: #aaaa;
		border-radius: 10px;
	}
}
.beetronix{
    font-size: .8rem;
    font-weight: bolder;
}
</style>
